<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="11">
        <WaybillTable
          ref="waybillTable"
          :listSoBillCode="listSoBillCode"
          :listSoBillDetailCode="listSoBillDetailCode"
          :current-key="waybillCode"
          @change="waybillChange"
        />
      </el-col>
      <el-col :span="13">
        <VehicleTable
          ref="vehicleTable"
          :waybillCode="waybillCode"
          @change="vehicleChange = true"
        />
      </el-col>
    </el-row>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          取消
        </el-button>
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="confirm()" type="primary" size="small">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import WaybillTable from '../waybill-table'
import VehicleTable from '../vehicle-table'
export default {
  components: { VehicleTable, WaybillTable },
  props: {
    listSoBillCode: { type: Array, default: () => [] },
    listSoBillDetailCode: { type: Array, default: () => [] },
  },
  data() {
    return {
      waybill: {},
      vehicleChange: false,
      backDialogVisible: false,
    }
  },
  computed: {
    waybillCode() {
      return this.waybill.waybillCode
    },
  },
  methods: {
    async waybillChange(waybill) {
      if (this.vehicleChange) {
        const confirm = await this.$confirm(
          '是否要保存当前运单的用车信息？',
          '确认信息',
          { type: 'warning', confirmButtonText: '保存' }
        )
          .then(() => true)
          .catch(() => false)
        if (confirm) {
          if (!(await this.confirm(false))) return
        }
      }

      this.waybill = waybill
      this.vehicleChange = false
    },
    async confirm(showConfirm = true) {
      const result = await this.$refs.vehicleTable.validate()
      if (!result) return (this.backDialogVisible = false)

      if (showConfirm) {
        const confirm = await this.$confirm(
          '确认要对当前的SO账单，更新车辆信息吗？',
          '确认信息',
          { type: 'warning' }
        )
          .then(() => true)
          .catch(() => false)
        if (!confirm) return false
      }
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const vehicles = this.$refs.vehicleTable.getTableData()
      const { waybillCode, soBillCode } = this.waybill
      const params = { vehicles, waybillCode, soBillCode }
      
      const res = await this.$api
        .financeWaybillSetVehicleApi(params)
        .catch(() => null)
      loadingInstance.close()
      if (!res) return

      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      })
      this.vehicleChange = false
      this.$emit('reload')
      return true
    },
    cancel() {
      if (this.disabled || !this.vehicleChange) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
